import React from "react";
import { RCCGrid } from "react-common-components";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import Container from "./styles";

const PageWithoutBusinessGroupAccess: React.FC = () => {
	const { translate } = useTranslation();
	return (
		<Container>
			<Title color="purple" size="xl" bold marginBottom={16}>
				{translate("Você não tem acesso a nenhum grupo empresa")}
			</Title>
			<RCCGrid container item alignItems="center" justifyContent="center">
				<Title color="purple" size="sm">
					{translate("Para ter acesso a aplicação, solicite acesso a um grupo empresa")}
				</Title>
			</RCCGrid>
		</Container>
	);
};

export default PageWithoutBusinessGroupAccess;
